var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.537 115.25L300.766 9.375C294.638 3.375 286.263 0 277.636 0H174.364C165.737 0 157.362 3.375 151.234 9.375L43.463 115.25C35.461 123.125 32.211 134.625 34.961 145.625L122.103 487.75C125.729 502 138.733 512 153.735 512H298.39C313.267 512 326.271 502 329.897 487.75L417.039 145.625C419.789 134.625 416.539 123.125 408.537 115.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffin);
export default __webpack_public_path__ + "static/media/coffin.f697f6bc53e7785a8a5b95a2e9e33134.svg";
export { ForwardRef as ReactComponent };